import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal, Button, Form } from "react-bootstrap";
import { get } from "lodash";
import { isValidArray } from "../../../helper";
import UploadProjectIssueSingle from "./UploadProjectIssueSingle";
import TooltipCustom from "../TooltipCustom";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "../../../customToast";

export class UploadedListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProjectIssues: [],
      totalProjectCount: null,
      totalIssueCount: null,
      selectedProjectCount: null,
      selectedIssueCount: null,
      isNothingSelected: false
    };
  }

  componentDidMount() {
    const { uploadedList, alreadySelected } = this.props;
    const selectedProjects = get(uploadedList, "projectsData", []);
    const uploadedProjectCount = selectedProjects.length;
    let selectedIssues = [];
    get(uploadedList, "issuesData", []).forEach(issue => {
      selectedIssues.push({
        id: issue.id,
        creatorName: issue.creatorName,
        title: issue.title,
        description: issue.description,
        createdDate: issue.createdDate,
        status: issue.status,
        recipientGroup: issue.recipientState,
        assigneeGroup: issue.assigneeGroup,
        assignedForDays: issue.modifiedDate,
        category: issue.category,
        subCategory: issue.subCategory,
        meetingDecisionDTOS: issue.meetingDecisionDTOS,
        recipientGroupCategory: issue.recipientGroupCategory,
        recipientGroupId: issue.recipientGroupId,
        districtName: issue.districtName,
        districtDeptId: issue.districtDeptId,
        duplicate: issue.duplicate,
        displayActions: issue.displayActions,
        escalationLevelName: issue.escalationLevelName,
        secondaryMinistry: issue.secondaryMinistry,
        secondaryMinistryId: issue.secondaryMinistryId,
        secondaryMinistryDepartment: issue.secondaryMinistryDepartment,
        secondaryMinistryDepartmentId: issue.secondaryMinistryDepartmentId,
        secondaryState: issue.secondaryState,
        secondaryStateId: issue.secondaryStateId,
        secondaryStateDepartment: issue.secondaryStateDepartment,
        secondaryStateDepartmentId: issue.secondaryStateDepartmentId,
        secondaryRecipientGroupId: issue.secondaryRecipientGroupId,
        secondaryRecipientGroupName: issue.secondaryRecipientGroupName,
        project: {
          id: issue.projectId,
          totalCost: issue.totalCost,
          name: issue.projectName,
          sponsoredById: issue.sponsoredById,
          sponsoredBy: issue.sponsoringMinistry,
          displayId: issue.displayId,
          sponsoringMinistry: issue.sponsoringMinistryCategory,
          sponsoringDepartment: issue.sponsoringDepartment,
          pli: issue.pli,
          pragatiReview: issue.pragatiReview,
          nipReview: issue.nipReview,
          pmGatiShakti: issue.pmGatiShakti,
          pmFoundationStone: issue.pmFoundationStone,
          march24: issue.march24,
          organizationName: issue.organizationName,
          projectStatusWithRespectToIssueStatus:
            issue.projectStatusWithRespectToIssueStatus,
          projectCompletionDTO: issue.projectCompletionDTO,
          projectSector: issue.projectSector,
          projectCategory: issue.projectCategory,
          projectPPList: issue.projectPPList
        },
        isSelected: true,
        issuePragatiReview: issue.issuePragatiReview,
        issuePragatiPipeLine: issue.issuePragatiPipeLine,
        latestIssueComments: issue.latestIssueComments,
        projectCreatedBy: issue.projectCreatedBy,
        verificationDate: issue.verificationDate,
        recipientLabel: issue.recipientLabel
      });
      // }
    });

    const uploadedIssueCount = selectedIssues.length;

    let selectedProjectIssues = [];
    selectedProjectIssues = selectedProjects.map(selectedProject => {
      const updatedProject = {
        ...selectedProject,
        isSelected: true
      };
      updatedProject.issuesSelected = selectedIssues.filter(
        selectedIssue => selectedProject.id === selectedIssue.project.id
      );
      return updatedProject;
    });

    this.setState({
      selectedIssues: selectedIssues,
      selectedProjectIssues: selectedProjectIssues,
      totalProjectCount: uploadedProjectCount,
      totalIssueCount: uploadedIssueCount,
      selectedProjectCount: uploadedProjectCount,
      selectedIssueCount: uploadedIssueCount
    });
  }

  // toggleProjectSelection = (index) => {
  //   const updatedList = [...this.state.selectedProjectIssues];
  //   updatedList[index].isSelected = !updatedList[index].isSelected;

  //   this.setState({ selectedProjectIssues: updatedList });
  // };

  toggleSelection = (projectId, issueId = null) => {
    this.setState(prev => {
      const updated = prev.selectedProjectIssues.map(project => {
        if (project.id !== projectId) return project;

        // ------------ PROJECT TOGGLE ------------
        if (issueId === null) {
          const newState = !project.isSelected;

          return {
            ...project,
            isSelected: newState,
            issuesSelected: project.issuesSelected.map(i => ({
              ...i,
              isSelected: newState
            }))
          };
        }

        // ------------ SINGLE ISSUE TOGGLE ------------
        const updatedIssues = project.issuesSelected.map(i => {
          if (i.id !== issueId) return i;
          return {
            ...i,
            isSelected: !i.isSelected
          };
        });

        // NOTE: project.isSelected remains unchanged here
        return {
          ...project,
          issuesSelected: updatedIssues
        };
      });
      // -------- COUNTS --------
      const { alreadySelected } = this.props;
      const newlycheckedProjects = updated.filter(p => p.isSelected);
      const filteredCheckedProjects = newlycheckedProjects.filter(
        proj => !alreadySelected.some(a => a.id === proj.id)
      );
      const checkedProjects = filteredCheckedProjects.length;

      const checkedIssues = updated.reduce((count, project) => {
        return count + project.issuesSelected.filter(i => i.isSelected).length;
      }, 0);

      const isNothingSelected = checkedProjects === 0 && checkedIssues === 0;
      const selectedProjectCount = newlycheckedProjects.length;

      return {
        selectedProjectIssues: updated,
        selectedProjectCount: selectedProjectCount,
        selectedIssueCount: checkedIssues,
        isNothingSelected
      };
    });
  };

  mergeProjectsAndIssues = (projects = []) => {
    const map = new Map();

    projects.forEach(proj => {
      const existing = map.get(proj.id);

      if (!existing) {
        map.set(proj.id, {
          ...proj,
          issuesSelected: [...proj.issuesSelected]
        });
      } else {
        const mergedIssues = [
          ...existing.issuesSelected,
          ...proj.issuesSelected
        ];

        const uniqueIssues = [
          ...new Map(mergedIssues.map(i => [i.id, i])).values()
        ];

        map.set(proj.id, {
          ...existing,
          ...proj, // keeps latest project fields (e.g. isSelected)
          issuesSelected: uniqueIssues
        });
      }
    });

    return [...map.values()];
  };

  submitHandler = () => {
    const { selectedProjectIssues } = this.state;
    const { alreadySelected } = this.props;
    const alreadySelectedProjectIssues = alreadySelected.map(item => ({
      ...item,
      isSelected: true
    }));

    let selectedList = [
      ...selectedProjectIssues,
      ...alreadySelectedProjectIssues
    ];
    selectedList = this.mergeProjectsAndIssues(selectedList);

    const filteredSelectedData = selectedProjectIssues
      .filter(project => project.isSelected)
      .map(project => {
        return {
          ...project,
          issuesSelected: project.issuesSelected.filter(
            issue => issue.isSelected
          )
        };
      });
    const selectedProjectCount = filteredSelectedData.length;
    const selectedIssueCount = filteredSelectedData.reduce(
      (total, project) => total + project.issuesSelected.length,
      0
    );

    const { addInAgenda } = this.props;
    const filteredData = selectedList
      .filter(project => project.isSelected)
      .map(project => {
        return {
          ...project,
          issuesSelected: project.issuesSelected.filter(
            issue => issue.isSelected
          )
        };
      });

    addInAgenda(filteredData);
    toast.success(
      <p className="toast-text-alignment" style={{ textTransform: "none" }}>
        {selectedProjectCount} Project(s) Added Successfully
        <br />
        {selectedIssueCount} Issue(s) Added Successfully
      </p>,
      successToastStyle
    );
  };

  render() {
    const {
      show,
      closeModal,
      uploadedList,
      addInAgenda,
      alreadySelected
    } = this.props;
    const {
      selectedProjectIssues,
      totalProjectCount,
      totalIssueCount,
      selectedProjectCount,
      selectedIssueCount,
      isNothingSelected
    } = this.state;

    return (
      <React.Fragment>
        <Modal
          show={show}
          dialogClassName="modal-uploaded-list"
          onHide={closeModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Uploaded Projects ({totalProjectCount}) & Issues (
              {totalIssueCount}){" "}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="scroll">
            {isValidArray(selectedProjectIssues) ? (
              <div className="added-issue-list added-project-issue-list">
                {(selectedProjectIssues || []).map((itemProject, index) => {
                  const isDisabled = alreadySelected.some(
                    a => a.id === itemProject.id
                  );
                  return (
                    <UploadProjectIssueSingle
                      project={itemProject}
                      idx={index}
                      key={index}
                      alreadyAddedData={alreadySelected}
                      isDisabled={isDisabled}
                      onToggle={(projectId, issueId) =>
                        this.toggleSelection(projectId, issueId)
                      }
                    />
                  );
                })}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer className="sticky-footer">
            <div className="selected-issues">
              Selected Projects: <span>{selectedProjectCount}</span>{" "}
              <span className="verticle-bar"> | </span>
              Selected Issues: <span>{selectedIssueCount}</span>
            </div>
            {isNothingSelected ? (
              <TooltipCustom text="Select one or more Projects/Issues to proceed">
                <Button
                  className="btn-orange no-padding"
                  onClick={this.submitHandler}
                  disabled={isNothingSelected}
                >
                  Add in Agenda
                </Button>
              </TooltipCustom>
            ) : (
              <Button
                className="btn-orange no-padding"
                onClick={this.submitHandler}
                disabled={isNothingSelected}
              >
                Add in Agenda
              </Button>
            )}

            <Button
              className="btn-orange-invert no-padding btn-cancel"
              onClick={closeModal}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    uploadProjectIssuesReducer: state.donwloadExcelReducer.uploadProjectIssues,
    uploadedList: state.donwloadExcelReducer.uploadProjectIssues.uploadedList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      //uploadProjectIssuesAction,
      //clearUploadProjectIssuesAction,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadedListModal);
